// extracted by mini-css-extract-plugin
export var container = "MiniFooter-module__container___snKbn";
export var rightsReserved = "MiniFooter-module__rightsReserved___GMqFG";
export var links = "MiniFooter-module__links___FojmT";
export var text = "MiniFooter-module__text___WAQ9O";